import React from 'react';

/**
 * Stewie character logo/avatar component.
 * Use size="sm" for headers, "md" for featured spots, "lg" for hero areas.
 */
export function StewieLogo({ size = 'sm', className = '' }) {
  const sizes = {
    sm: { width: 40, height: 40, borderRadius: '50%' },
    md: { width: 64, height: 64, borderRadius: '50%' },
    lg: { width: 120, height: 120, borderRadius: '16px' },
  };
  const s = sizes[size] || sizes.sm;

  return (
    <img
      src="/stewie_front.png"
      alt="Stewie"
      className={`stewie-logo ${className}`}
      data-testid="stewie-logo"
      style={{
        width: s.width,
        height: s.height,
        borderRadius: s.borderRadius,
        objectFit: 'cover',
        objectPosition: 'center 25%',
        flexShrink: 0,
        border: '2px solid #334155',
      }}
    />
  );
}

/**
 * Full header with Stewie avatar + title text.
 * Drop-in replacement for page header sections.
 */
export function StewieHeader({ title, subtitle, size = 'sm', children }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: size === 'sm' ? 12 : 16 }} data-testid="stewie-header">
      <StewieLogo size={size} />
      <div style={{ flex: 1 }}>
        {title && <div style={{ fontSize: size === 'lg' ? 28 : 18, fontWeight: 700, color: '#f8fafc', lineHeight: 1.2 }}>{title}</div>}
        {subtitle && <div style={{ fontSize: 13, color: '#64748b', marginTop: 3 }}>{subtitle}</div>}
      </div>
      {children}
    </div>
  );
}
